<template>
  <div></div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "EdSession",
  components: {},
  data: () => ({
    visible: false,
    snackbar: {
      enabled: false,
      color: "success",
      mode: "multi-line",
      timeout: 4000,
      message: "Success!",
      callback: null,
      location: "bottom",
      close: {
        text: "Close",
        color: "",
      },
    },
  }),
  mounted() {
    this.$utilidade.console("::EdSession module loaded::");
  },
  computed: {
    ...mapGetters("common", ["getConfig", "getLocation","getVersion"]),
    ...mapGetters("usuario", ["getUsuarioLogado"]),
    ...mapGetters("cliente", ["getClienteLogado"]),
  },
  watch: {
    getUsuarioLogado() {
      this.setEvents();
    },
  },
  methods: {
    ...mapActions("cliente", ["setClienteLogado"]),
    ...mapActions("usuario", ["setUsuarioLogado"]),
    ...mapActions("common", ["setConfig","setLocation","setVersion"]),

    minhaLocalizacao() {
      if (!("geolocation" in navigator)) {
        return;
      }

      navigator.geolocation.getCurrentPosition(
        (pos) => {
          this.setLocation(pos);
        },
        (err) => {
          this.setLocation(null);
        }
      );
    },

    setEvents() {
      let usuarioLogado = this.getUsuarioLogado;
      let self = this;

      if (usuarioLogado) {
        this.$root.$socket
          .publicChannel("AuthChannel")
          .listen(
            "." + usuarioLogado.tipo_usuario.id + "TipoUsuarioNotifyEvent",
            function (data) {
              self.$root.$notify.info(data.data);
            }
          );

        this.$root.$socket
          .publicChannel("AuthChannel")
          .listen(
            "." + usuarioLogado.tipo_usuario.id + "UsuarioNotifyEvent",
            function (data) {
              self.$root.$notify.info(data.data);
            }
          );
      }
    },

    login(result) {
      this.$cookie.set(this.getConfig.jwt, result.data.token, {
        expires: "12h",
      });
      this.setUsuarioLogado(result.data);
      this.$router.push({ name: "auth.home" });
    },

    logout() {
      this.$root.$dialog
        .confirm(
          "Deseja realmente sair do sistema? Dados não salvos poderão ser perdidos."
        )
        .then(() => {
          this.$root.$loading.set(true);

          this.$root.$request.post("auth/logout").then((result) => {
            this.$root.$loading.set(false);
            this.limparSessao();
          });
        });
    },

    limparSessao() {
      this.setUsuarioLogado(null);
      this.$cookie.delete(this.getConfig.jwt);
      this.$router.push({ name: "auth.login" });
    },

    validarSessao() {
      if (!this.$cookie.get(this.getConfig.jwt)) return false;
      else return true;
    },

    validarPermissao(permissao) {
      if (!this.getUsuarioLogado) return false;

      if (this.getUsuarioLogado.tipo_usuario.id == 2) return true;

      if (
        this.$utilidade.arrFindByField(
          this.getUsuarioLogado.permissoes,
          "id",
          permissao
        )
      )
        return true;

      return false;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/root/EdSession.vue